import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { CurrentUserService } from 'services/currentUser';
import {
    getActiveEarthquakePartnerProduct,
    getActiveWindPartnerProduct
} from 'common/source/utilities/policyInfoHelper';
import { IAugmentedJQuery } from 'angular';

import * as _ from 'lodash';

const module = angular.module('coverage-earthquake-coverage-section', []);

interface CoverageEarthquakeCoverageSectionController extends angular.IStrictController {
    title: string;
    icon: string;
    description: string;
    partnerName: string;
    partnerContactNumber?: string;
    policyNumber: string;
}

module.component('coverageEarthquakeCoverageSection', {
    template: template,
    controller: function(
        this: CoverageEarthquakeCoverageSectionController,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams,
        $element: IAugmentedJQuery
    ) {
        'ngInject';

        this.$onInit = () => {
            this.title = 'Earthquake';
            this.icon = 'earthquake';

            const policyIndex = $stateParams.policyIndex;

            currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                const earthquakePartnerProduct = getActiveEarthquakePartnerProduct(policyInfo);

                if (earthquakePartnerProduct) {
                    const carrier = earthquakePartnerProduct.carrier;
                    const broker = earthquakePartnerProduct.broker;

                    if (broker === 'arrowhead' || (broker !== 'arrowhead' && carrier === 'palomar_specialty')) {
                        this.partnerContactNumber = '877-233-9722';
                    }

                    this.partnerName = _.startCase(carrier);
                    this.policyNumber = earthquakePartnerProduct.policy_number;
                    this.description = `
                        Smart move. You purchased earthquake coverage, with a policy effective date of
                        ${earthquakePartnerProduct.date}.`;
                } else {
                    $element.find('icon-title-section').addClass('ng-hide');
                }
            });
        };
    }
});

export { module };
